__turbopack_context__.v({
  "root": "styles-module-scss-module__x7LXXa__root",
  "rootPaginationList": "styles-module-scss-module__x7LXXa__rootPaginationList",
  "select": "styles-module-scss-module__x7LXXa__select",
});
